module.exports = __webpack_public_path__ + "static/img/m_name.1117ee8.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/bn/m_name.png
// module id = 64jf
// module chunks = 7